export default function style(main) {
    var _main = main;

    return function child(sub, main = _main) {
        if (!sub) return main
        
        return `${main}__${sub}`; 
    }
}